import { UUID } from 'v2/core/entities/uuid';

const MAX_WORDS_IN_SLUG = 4;
const MAX_CHARS_IN_SLUG = 30;
const SLUG_SEPARATOR = '-';
const PARTS_IN_UUID = 5;

const filterAlphaNumeric = (name: string): string =>
  name.replace(/[\W_]+/g, ' ');

const truncateName = (name: string): string => {
  const words = filterAlphaNumeric(name).split(' ').filter(Boolean);
  const slugWords = words.slice(0, Math.min(MAX_WORDS_IN_SLUG, words.length));
  const slug = slugWords.join(SLUG_SEPARATOR);
  return slug.length < MAX_CHARS_IN_SLUG
    ? slug
    : slug.substring(0, MAX_CHARS_IN_SLUG);
};

export const getSavedSlug = ({
  token,
  name,
}: {
  token: UUID;
  name: string;
}): string => {
  // Slug is:
  // /truncated-analysis-name-<analysis-view-token>
  return `${truncateName(name)}-${token}`;
};

export const getTokenFromSavedSlug = (slug: string): UUID | undefined => {
  // Slug is:
  // /truncated-analysis-name-<analysis-id>
  const slugParts = slug.split(SLUG_SEPARATOR);
  // invalid slug
  if (slugParts.length < PARTS_IN_UUID) {
    return;
  }
  return slugParts.slice(slugParts.length - PARTS_IN_UUID).join('-');
};
